/*****************************************************************
 ** Copyright (c) 帕加马
 ** 创建人:      ly
 ** 创建日期:    2020/10/01
 ** 修改人:
 ** 修改日期:
 ** 描 述:
 **    自定义的axios 第3个参数（config）字段意义
 **          showError:true表示ajax出错时，弹出alert框提示。默认不弹出
 **          noToken:true表示请求时，不在header中带入token。默认带入
 **          maskOptions:表示请求时显示遮罩层的选项。默认{body: true}
 **-----------------------------------------------------------------
 ******************************************************************/
import { message } from 'antd';
import axios from 'axios';

axios.defaults.baseURL = UMI_API_SERVER;
// axios.defaults.headers['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.post['Content-Type'] = 'application/json;';
axios.defaults.headers.put['Content-Type'] = 'application/json';

// axios.defaults.withCredentials = true;
axios.defaults.timeout = 450000; // 45秒，超时报错

axios.defaults.transformRequest = function (request, header) {
  // `transformRequest` 允许在向服务器发送前，修改请求数据
  // 只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
  // 后面数组中的函数必须返回一个字符串，或 ArrayBuffer，或 Stream
  if (request instanceof FormData) {
    return request;
  } else {
    return JSON.stringify(request);
  }
};

// http请求拦截器
axios.interceptors.request.use(function (config) {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  if (userInfo && userInfo.token) {
    config.headers.TOKEN = userInfo.token;
  }
  return config;
}, fail);

// http响应拦截器
axios.interceptors.response.use(function (res) {
  if (res.data.code == '40001') {
    console.log('next-axios-path-------', window.location.href);
    // token失效时记录当前路径
    localStorage.setItem('nextPath', window.location.href);

    window.location.href = UMI_H5HOST + '/litta-palmer/login';
    return;
  }

  // 配置下载的列表
  const downloadWhiteList = [
    '/v1/litta/order/export',
    '/v1/third/order/export',
    '/renew/export',
  ];
  if (downloadWhiteList.indexOf(res?.config?.url) >= 0) {
    return res;
  }
  return res.data;
}, fail);

function fail(error) {
  const msg = '网络异常，请稍后重试';
  return Promise.reject(error || msg);
}

export default axios;
